<template>
  <div>
    <div class="modal" :class="{'is-active':showModal}">
      <div class="modal-background" @click="closeModal()"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">New Message</p>
          <button class="delete" aria-label="close" @click="closeModal()"></button>
        </header>
        <section class="modal-card-body">
          <p style="padding-bottom:1em">{{message}}</p>
          <form>
            <div class="control">
              <label class="label">Reply</label>
              <textarea class="textarea" type="text" v-model="reply"/>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button is-success"
            :class="{'is-loading':sending}"
            @click="replyMessage()"
          >Reply</button>
          <button class="button" @click="closeModal()">Close</button>
        </footer>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="content-card">
          <div class="card-title">
            <h1>Notifications And Messages:</h1>
          </div>
          <div class="content">
            <div class="list is-hoverable">
              <div
                class="list-item"
                v-for="msg in notifications"
                :key="msg._id"
                :class="{'is-active':!msg.seen}"
              >
                <div class="level">
                  <div class="level-left">
                    <div class="level-item">
                      <p>{{msg.subject}}</p>
                    </div>
                  </div>
                  <div class="level-right">
                    <div class="level-item">
                      <div class="field is-grouped">
                        <p class="control" :class="{'is-hidden':msg.seen}">
                          <a class="button is-warning is-small">Not Read</a>
                        </p>
                        <p class="control">
                          <a class="button is-success is-small" @click="showMessage(msg)">View</a>
                        </p>
                        <p class="control">
                          <a
                            class="button is-danger is-small"
                            @click="deleteNotification(msg._id)"
                          >Delete</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import alertify from 'alertifyjs';
import axios from "axios";

export default {
  data: function() {
    return {
      message: "",
      showModal: false,
      subject: "",
      sending: false,
      reply: ""
    };
  },
  methods: {
    ...mapActions(["readNotification", "deleteNotification"]),
    showMessage(message) {
      this.message = message.message;
      this.subject = message.subject;
      this.showModal = true;
      this.readNotification(message);
    },
    closeModal() {
      this.showModal = false;
    },
    replyMessage() {
      this.sending = true;
      if (this.reply) {
        axios
          .post("/api/notification/send", {
            receiverID: "",
            message: this.reply,
            kind: "help",
            ownerKind: "admin",
            subject:'Notification Reply'
          }, {withCredentials: true})
          .then(response => {
            this.sending = false;
            var body = response.data;
            console.log(response);
            if (body.success) {
              alertify.success("message sent");
              this.showModal = false
            } else {
              this.showModal = false
              alertify.error("error sending message");
            }
          })
          .catch(error => {
            this.sending = false;
            alertify.error("Error Sending Message");
          });
      } else {
        this.sending = false;
        alertify.error("cant send empty message");
      }
    }
  },
  computed: mapState(["notifications"])
};
</script>

<style scoped>
.content-card {
  background: #fff;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11);
}

.card-title {
  background-color: #00b89c;
  padding: 1em;
}
.card-title h1 {
  color: #fff;
  text-align: center;
  font-size: 1.2rem;
}
.content {
  padding: 1rem 1.5rem 1rem;
}

.not-shown {
  visibility: hidden;
}
.card {
  background: #fff;
  width: 24rem;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11);
  padding: 3rem 2.5rem 5rem;
}

.sub-btn-container {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}

input:focus {
  box-shadow: none;
  border-color: #00d1b2;
}
</style>